import * as React from 'react';
import { useSelector } from 'react-redux';

import { MessageImagesLayout } from '../../../../components/MessageImagesLayout';
import { currentOpenChatIDSelector } from '../../../../selectors';
import { IImageFile } from '../../../../types/imageFile';
import { TMessage, TOutcomingStatus } from '../../../../types/messages';
import { ChatImageContainer } from '../../../ChatImageContainer';
import { ChatImageDraftContainer } from '../../../ChatImageDraftContainer';
import { useMessageImages } from '../../hooks/useMessageImages';

interface IImageMessageContainerProps {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
}

export const ImageMessageContainer: React.FC<IImageMessageContainerProps> = ({ message, messageId }) => {
  const { status } = message;
  const chatId = useSelector(currentOpenChatIDSelector);
  const { imageBlobFiles, imageFiles } = useMessageImages({ message, messageId });

  const images = React.useMemo(() => {
    if (imageBlobFiles.length) {
      return imageBlobFiles.map(({ file, cancellationToken }) => (
        <ChatImageDraftContainer
          key={file?.lastModified}
          file={file}
          messageId={messageId}
          cancellationToken={cancellationToken}
          messageStatus={status}
          isGalleryItem={imageBlobFiles.length > 1}
        />
      ));
    }

    if (imageFiles?.length) {
      return imageFiles.map((image: IImageFile) => (
        <ChatImageContainer key={image.uid} image={image} isGalleryItem={imageFiles.length > 1} withFullscreen />
      ));
    }

    return [];
  }, [imageBlobFiles, imageFiles, messageId, status]);

  if (!images.length) {
    return null;
  }

  return images.length > 1 ? <MessageImagesLayout images={images} uniqueKey={`${chatId}_${messageId}`} /> : images[0];
};
